const EmojiPickerView = Backbone.View.extend({
  className: 'emoji-picker',

  initialize() {
    const that = this;

    _.bindAll(this, 'addEmoji');

    this.options.$pickerTrigger.removeClass('active');

    this.options.$pickerTrigger.on('click', _.bind(this.toggle, this));

    Promise.all([import('../../../react/EmojiMart/EmojiMart.js')]).then(
      ([EmojiMart]) => {
        that.EmojiMart = EmojiMart.default;
      },
    );
  },

  addEmoji(emoji) {
    Utils.sendUsedContentGAInfo('Emoji');

    if (this.options.onSelect) {
      this.options.onSelect(emoji.native);
      Utils.trackPendoEvent('Selected Emoji');
    }

    this.close();
  },

  render() {
    return this;
  },

  toggle(e) {
    e.stopPropagation();
    if (this.options.$pickerTrigger.hasClass('active')) {
      this.close();
    } else {
      this.show();
    }
  },

  show() {
    const pos = this.options.$pickerTrigger.offset();
    const windowHeight = window.innerHeight;
    const leftOffset = 342;
    const leftOffset_onboarding = 375;
    const { isOnboarding } = this.options.composeView.options;
    const topPos = this.options.$pickerTrigger.offset().top;
    const leftPos = isOnboarding
      ? pos.left - leftOffset_onboarding
      : pos.left - leftOffset;
    const heightCorrection = 35;

    if (this.options.$pickerTrigger.hasClass('disabled')) {
      return;
    }

    this.emojiMart = new this.EmojiMart({
      el: this.$el[0],
      serviceType: this.options.serviceType,
      addEmoji: this.addEmoji,
    });

    this.emojiMart.render();

    const css = {
      top: pos.top + 35,
      left: leftPos + 15,
      display: 'block',
      transform: 'translateX(calc(100% - 34px))',
    };

    setTimeout(
      _.bind(function () {
        Backbone.trigger(
          'onboarding::set-height',
          this.options.composeView.$el.height() + 175,
        );
      }, this),
      0,
    );

    this.options.$pickerTrigger.addClass('active');

    this.$el.css(css);
    this.$el.css('zIndex', 99999).addClass('in');

    const elheight = this.$el.find('.emoji-mart').height() + heightCorrection;

    if (!isOnboarding && windowHeight - topPos < elheight) {
      css.top -= elheight;
      css.left = leftPos - 20;
      this.$el.css(css);
    }
  },

  close() {
    if (this.emojiMart) {
      this.emojiMart.unmountFromDom();
    }

    delete this.emojiMart;

    this.options.$pickerTrigger.removeClass('active');
    this.$el.removeClass('in');

    setTimeout(
      _.bind(function () {
        this.$el.css({
          zIndex: -99999,
          left: '-9999px;',
          display: 'none',
        });
      }, this),
      200,
    );
  },

  cleanup() {
    this.close();
    this.options.$pickerTrigger.off('click');
    this.unbind();
    this.remove();
  },
});

export default EmojiPickerView;
